import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a827d18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { style: {"width":"80%"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, " 数据统计 ", -1))
const _hoisted_4 = { class: "b1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "公司数量", -1))
const _hoisted_6 = { class: "b2" }
const _hoisted_7 = { class: "b2" }
const _hoisted_8 = { class: "b2" }
const _hoisted_9 = { class: "b1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "用户数", -1))
const _hoisted_11 = { class: "b2" }
const _hoisted_12 = { class: "b2" }
const _hoisted_13 = { class: "b1" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "订单数", -1))
const _hoisted_15 = { class: "b2" }
const _hoisted_16 = { class: "b2" }

import { reactive, onMounted, provide, ref } from 'vue'
import api from '@/api/index'
import { ElMessage, ElLoading } from 'element-plus'
import * as echarts from "echarts"

export default /*#__PURE__*/_defineComponent({
  __name: 'Statistics',
  setup(__props) {

provide("echarts", echarts)
const baseData:any = reactive({
  company_freeze_count:0,
  company_audit_count:0,
  company_count:0,
  company_normal_count:0,
  member_count:0,
  member_freeze_count:0,
  member_normal_count:0,
  order_count:0,
  order_nopay_count:0,
  order_pay_count:0,
  companyList:[],
  order_data:{
    date:[],
    count:[],
  }
});
const searchForm:any = reactive({
  companyid:"",
  status:"",
  TimeRange:[],
});
const getInfo = () => {
  const loading = ElLoading.service({lock: true})
  let data = {
    companyid:searchForm.companyid,
    status:searchForm.status,
    start_time:searchForm.TimeRange[0],
    end_time:searchForm.TimeRange[1],
  }
  api.accessoryApi.getInfo(data).then((res:any)=>{
    if(res.code==200){
      baseData.company_freeze_count = res.data.company_freeze_count
      baseData.company_audit_count = res.data.company_audit_count
      baseData.company_count = res.data.company_count
      baseData.company_normal_count = res.data.company_normal_count
      baseData.member_count = res.data.member_count
      baseData.member_freeze_count = res.data.member_freeze_count
      baseData.member_normal_count = res.data.member_normal_count
      baseData.order_count = res.data.order_count
      baseData.order_pay_count = res.data.order_pay_count
      baseData.order_nopay_count = res.data.order_nopay_count
      baseData.order_data = res.data.order_data
      createMemberEchart()
    }else{
      ElMessage.error(res.message)
    }
    loading.close()
  })
  loading.close()
}

const memberChart = ref()
const memberOption = {
  title: {
    text: '订单数'
  },
  xAxis: {
    type: 'category',
    data: baseData.order_data.date
  },
  yAxis: {
    type: 'value'
  },
  tooltip: {
    trigger: 'item'
  },
  series: [
    {
      data: baseData.order_data.count,
      type: 'line'
    }
  ]
};
const createMemberEchart = () => {
  let memberChartEl = memberChart.value
  let userEc = echarts.init(memberChartEl, "light")
  console.log(baseData.order_data)
  memberOption.series[0].data = baseData.order_data.count
  memberOption.xAxis.data = baseData.order_data.date
  userEc.setOption(memberOption)
}
const getCompanyList = () => {
  api.companyApi.alllist({}).then((res:any)=>{
    if(res.code==200){
      baseData.companyList = res.data.list
    }else{
      ElMessage.error(res.message)
    }
  })
}
onMounted(() => {
  let start_time = new Date().getTime()-86400000*7
  let end_time = new Date().getTime()
  let start_time_morth = new Date(start_time).getMonth() + 1 > 9 ? new Date(start_time).getMonth() + 1 : '0'+ (new Date(start_time).getMonth()+1)
  let end_time_morth = new Date(end_time).getMonth() + 1 > 9 ? new Date(end_time).getMonth() + 1 : '0'+ (new Date(end_time).getMonth()+1)
  let start_date = new Date(start_time).getFullYear() + "-"+ start_time_morth + "-"+ (new Date(start_time).getDate() > 9 ? new Date(start_time).getDate() : "0" + new Date(start_time).getDate()) + " 12:00:00"
  let end_date = new Date(end_time).getFullYear() + "-"+ end_time_morth + "-"+ (new Date(end_time).getDate() > 9 ? new Date(end_time).getDate() : "0" + new Date(end_time).getDate()) + " 12:00:00"
  searchForm.TimeRange = [ start_date, end_date ]
  getCompanyList()
  getInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_breadcrumb, {
            class: "breadcrumb",
            separator: "/"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("工作台")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form, {
            model: searchForm,
            inline: "",
            "label-width": "140px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "时间范围" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: searchForm.TimeRange,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.TimeRange) = $event)),
                    type: "datetimerange",
                    "range-separator": "至",
                    "start-placeholder": "开始时间",
                    "end-placeholder": "结束时间",
                    format: "YYYY-MM-DD hh:mm:ss",
                    "value-format": "YYYY-MM-DD hh:mm:ss"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: getInfo
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("搜索")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"20px"}
    }, {
      header: _withCtx(() => [
        _hoisted_3
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("p", null, _toDisplayString(baseData.company_count), 1),
                    _createElementVNode("div", _hoisted_6, [
                      _createTextVNode("正常数量："),
                      _createElementVNode("em", null, _toDisplayString(baseData.company_normal_count), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createTextVNode("待审核数量："),
                      _createElementVNode("em", null, _toDisplayString(baseData.company_audit_count), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createTextVNode("冻结数量："),
                      _createElementVNode("em", null, _toDisplayString(baseData.company_freeze_count), 1)
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("p", null, _toDisplayString(baseData.member_count), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createTextVNode("正常数量："),
                      _createElementVNode("em", null, _toDisplayString(baseData.member_normal_count), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createTextVNode("冻结数量："),
                      _createElementVNode("em", null, _toDisplayString(baseData.member_freeze_count), 1)
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("p", null, _toDisplayString(baseData.order_count), 1),
                    _createElementVNode("div", _hoisted_15, [
                      _createTextVNode("待支付："),
                      _createElementVNode("em", null, _toDisplayString(baseData.order_nopay_count), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createTextVNode("已支付："),
                      _createElementVNode("em", null, _toDisplayString(baseData.order_pay_count), 1)
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            ref_key: "memberChart",
            ref: memberChart,
            style: {"width":"100%","height":"400px"}
          }, null, 512)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})